import { cleanPhone } from '@vox/frontend-react-ui/phone';

export { cleanPhone, formatRussianPhoneInput, isValidRussianPhone } from '@vox/frontend-react-ui/phone';

/** Сохраняет поиск по имени и приводит полный телефон к единому формату */
export const normalizePersonSearchQuery = (query: string): string => cleanPhone(query) ?? query.trim();
